import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';
import { EGameStates } from '@Managers/StateManager/GameStates';

export class TransactionCycleManager {
    private readonly game: Game;
    private readonly gameStore: GameStore;
    constructor(game: Game) {
        this.game = game;
        this.gameStore = this.game.gameStore;

        EventsCenter.on(EGameStates.SPIN_STATE, this.onSpinStart, this);
        EventsCenter.on(EGameStates.IDLE_STATE, this.onIdle, this);
        EventsCenter.on(EGameStates.COMPLETE_GAMBLE_STATE, this.endCycle, this);
        EventsCenter.on(EGameEvents.TAKE, this.endCycle, this);
    }

    private onSpinStart(): void {
        if (this.gameStore.get(EGameStoreKeys.TransactionCycleStarted)) return;
        this.gameStore.set(EGameStoreKeys.TransactionCycleStarted, true);
        EventsCenter.emit(EGameEvents.TRANSACTION_CYCLE_START);
    }

    private onIdle(): void {
        if (this.gameStore.get(EGameStoreKeys.SpinOutcome)?.win && this.gameStore.get(EGameStoreKeys.SpinOutcome).win > 0) return;

        this.endCycle();
    }

    private endCycle(): void {
        if (!this.gameStore.get(EGameStoreKeys.TransactionCycleStarted)) return;
        this.gameStore.set(EGameStoreKeys.TransactionCycleStarted, false);
        EventsCenter.emit(EGameEvents.TRANSACTION_CYCLE_END);
    }
}
